export default "__VITE_ASSET__suDUd_2CvH2KHOEKRz$qUw__"